import type { FaireProductEntity } from "../../entity_types/product";

export const p_enmra4pcwt: FaireProductEntity = {
  token: "p_enmra4pcwt",
  type: "product",
  name: "Embellished Cropped Pearl Trimmed Knit Cardigan",
  brandToken: "b_hrmradn4yd",
  brandName: "EmberLoom",
  imageUrl:
    "https://cdn.faire.com/fastly/d4320413e61a35416d9840c15d4bb184894f66fb29e838578dff3f01bc3587b7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ab68092959aa12413a1a5876648fe76b9c2dc5ae005669b43c10a2cde0326bd.jpeg",
    "https://cdn.faire.com/fastly/c20c1af2ac8c2a3a2898537075810626ed58a583c24e8c7719bc74399d4cac03.jpeg",
    "https://cdn.faire.com/fastly/4c9521b399183f648e8d6d058163d033cb6a0dff8552aacb20483cd40b58596b.jpeg",
    "https://cdn.faire.com/fastly/a6675714cae967e8e06fa4f6278c0672afcf5f29fb472150c0ed35c62da6c960.jpeg",
    "https://cdn.faire.com/fastly/afdbbf8b862e0d122a899f79ef28b808032a16ec21cf4b86b15977acfa86cde0.jpeg",
    "https://cdn.faire.com/fastly/ac587f6b1d325c449bb4cf258c4fb701f77132e31842b0d3f943e5bce8ae674b.jpeg",
    "https://cdn.faire.com/fastly/e0b1ba2a6c69c8534c6d09b2f3a30c9d11cc2f4f1d1d9b584d3a01bc6068dbc8.png",
  ],
  priceDollars: 18.98,
  description:
    "Embrace elegance with EmberLoom's Embellished Cropped Pearl Trimmed Knit Cardigan. This charming piece is a must-have addition to your wardrobe. The cardigan's intricate pearl embellishments elevate its aesthetic. Custom designed by Mrwolf, this cardigan embodies EmberLoom's commitment to creating unique apparel.\n2026 Embellished Cropped Round Neck Pearl Trimmed Knit Cardigan\nMain Fabric Composition\tPolyester (Polyester Fiber)\nThickness\tMedium Weight\nStyle\tOpen-Front Cardigan / Knit Jacket\nCraftsmanship\tBeaded / Pearl Embellishment\nPattern\t3D Textured Effect\nSet Type\tSingle Piece\nFit\tStraight Cut / Regular Fit\nSleeve Type\tRegular Sleeve\nNeckline\tRound Neck\nSleeve Length\tLong Sleeve\nKey Design Detail\tPearl Accents",
  tags: [],
  msrpDollars: 37.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:45.886Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
